// extracted by mini-css-extract-plugin
export default {"templateBox":"Template_templateBox__vz24V","deleteIcon":"Template_deleteIcon__Rj6Ka","deleteBox":"Template_deleteBox__AIpW1","previewBox":"Template_previewBox__TzRBr"};